import { render, staticRenderFns } from "./Plan-list.vue?vue&type=template&id=1f08e7eb"
import script from "./Plan-list.vue?vue&type=script&lang=js"
export * from "./Plan-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports